import { createClient } from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export const client = createClient({
  projectId: process.env.REACT_APP_SANITY_PROJECT_ID || '3bcawm4g',
  dataset: process.env.REACT_APP_SANITY_DATASET || 'production',
  apiVersion: '2023-04-19',
  useCdn: true,
});

const builder = imageUrlBuilder(client);

export function urlDeImagen(source) {
  return builder.image(source);
}

export function obtenerUrlDePrimeraImagen(arrayDeImagenes) {
  const imagen = arrayDeImagenes?.[0]?.imagen;

  if (!imagen) return '';

  return urlDeImagen(imagen)
    .width(1600)
    .quality(75)
    .auto('format')
    .url();
}
